export default "__VITE_ASSET__BbKCl6PV__"